/**
 * Google Ads Conversion Tracking — RAF Direct
 * Conta: AW-18377265401
 *
 * gtag.js já é carregado no <head> do public/index.html com Consent Mode v2
 * (default denied). O CookieBanner LGPD que atualiza pra `granted`.
 *
 * Dispara 2 conversões:
 *  1. wa_click  → AW-18377265401/TcNeCLuT6OccEPmh-7pE
 *  2. form_send → AW-18377265401/FmsSCL6T6OccEPmh-7pE
 *
 * Sempre chame via `trackAdsConversion(kind)` — o helper é no-op se gtag
 * não estiver disponível (SSR, testes, ad-blocker) ou se o consent estiver
 * negado.
 */
const AW_ACCOUNT = "AW-18377265401";
const LABELS = {
  wa_click: "TcNeCLuT6OccEPmh-7pE",
  form_send: "FmsSCL6T6OccEPmh-7pE",
};

export function trackAdsConversion(kind, extra = {}) {
  try {
    const label = LABELS[kind];
    if (!label || typeof window === "undefined" || !window.gtag) return;
    window.gtag("event", "conversion", {
      send_to: `${AW_ACCOUNT}/${label}`,
      ...extra,
    });
  } catch { /* ad-block/erro silencioso */ }
}

/**
 * Bootstrap um listener global que dispara `wa_click` sempre que o usuário
 * clica em qualquer elemento cujo `href` (ou `href` do ancestral <a>) aponta
 * pra wa.me ou api.whatsapp.com. Assim cobrimos os 21 pontos do código sem
 * precisar tocar cada botão individualmente.
 *
 * Idempotente — pode ser chamado múltiplas vezes sem duplicar listeners.
 */
let _waListenerAttached = false;
export function attachGlobalWaClickTracker() {
  if (_waListenerAttached || typeof document === "undefined") return;
  _waListenerAttached = true;

  const isWhatsappUrl = (url) => {
    if (!url || typeof url !== "string") return false;
    return /(?:^|\/\/|\.)(?:wa\.me|api\.whatsapp\.com|web\.whatsapp\.com)/i.test(url);
  };

  document.addEventListener("click", (e) => {
    try {
      const el = e.target?.closest?.("a[href], button[data-wa-track]");
      if (!el) return;
      const href = el.getAttribute("href") || el.getAttribute("data-wa-target") || "";
      if (isWhatsappUrl(href) || el.hasAttribute("data-wa-track")) {
        trackAdsConversion("wa_click", { link_url: href.slice(0, 120) });
      }
    } catch { /* silent */ }
  }, { capture: true, passive: true });
}
